// extracted by mini-css-extract-plugin
export var wordContainer = "_l4-0";